import { useState } from "react";
import { useHistory } from "@/compat/router";
import RiskAssessmentCompletedCard from "../../components/riskassessments/RiskAssessmentCompletedCard";
import moduleAreas, { moduleUrls } from "../../constants/moduleAreaConstants";
import { UPLOAD_RESULT_KEY } from "../../constants/riskAssessmentUploadConstants";
import { baseRoute } from "../../routes";

type Created = { id?: number; name: string };

export default function UploadRiskAssessmentComplete() {
    const history = useHistory();

    const [created] = useState<Created[]>(() => {
        try {
            const raw = sessionStorage.getItem(UPLOAD_RESULT_KEY);
            return raw ? (JSON.parse(raw) as Created[]) : [];
        } catch {
            return [];
        }
    });

    const raBase = `${baseRoute}/${moduleUrls[moduleAreas.RISKASSESSMENTS]}`;
    const single = created.length === 1 ? created[0] : null;

    // Consume the handoff on leaving so a later visit (without a fresh upload) can't reuse a stale RA.
    const goTo = (path: string) => {
        sessionStorage.removeItem(UPLOAD_RESULT_KEY);
        history.push(path);
    };

    const heading = single
        ? `${single.name} uploaded`
        : created.length > 1
            ? `${created.length} risk assessments uploaded`
            : "Risk assessment uploaded";

    return (
        <RiskAssessmentCompletedCard
            heading={heading}
            subtitle="Saved to the register. It can now be downloaded, shared for acknowledgement, and reviewed by uploading a new version."
            onView={single?.id ? () => goTo(`${raBase}/view/${single.id}`) : () => goTo(raBase)}
            primaryLabel={single?.id ? "View Assessment" : "Go to Risk Assessments"}
            onShare={single?.id ? () => goTo(`${raBase}/view/${single.id}?share=1`) : undefined}
            onBack={() => goTo(raBase)}
        />
    );
}
